// Ultimate Card Game (UCG) - Battlefield Map Selection
//
// Five backdrops exist: 'human' (the original skyline/lane, background.js's
// long-standing renderStaticBackground()), 'sul' (the Sul homeworld -
// see backgroundSul.js), 'swamp' (Xeno Swamp bioluminescent rainforest -
// see backgroundSwamp.js), 'voidglass' (a transparent glass deck
// hurtling through deep space, starfield streaming past underneath - see
// backgroundVoidglass.js), and 'stratos' (a heavy stratospheric dreadnought
// cruising across alpine mountain massifs at sunset - see backgroundStratos.js).
// Which one a LOCAL match gets follows the
// onboarding rules below. Online matches never call into this file at all:
// the server dices mapId once (server/matchRoom.js, right next to simSeed)
// and ships it to both peers in MATCH_START, for the same reason simSeed is
// server-decided - two independently-random clients could render two
// different maps for the same match.

export const MAP_IDS = ['human', 'sul', 'swamp', 'voidglass', 'stratos'];

const SESSION_FIRST_MAP_KEY = 'ucg_session_first_map_shown';

export function pickRandomMapId() {
  return MAP_IDS[Math.floor(Math.random() * MAP_IDS.length)];
}

// Local-match-only. playerRace is the western base's race for the match
// about to start (already resolved via cardSystem.setDeck() by the time
// this is called).
//   1. First local match this browser session -> always the map matching
//      the player's own race (Human -> 'human', Sul -> 'sul').
//   2. Everything else -> uniformly random.
export function chooseLocalMapId(playerRace) {
  let isFirstThisSession = true;
  try {
    isFirstThisSession = sessionStorage.getItem(SESSION_FIRST_MAP_KEY) !== 'true';
    if (isFirstThisSession) sessionStorage.setItem(SESSION_FIRST_MAP_KEY, 'true');
  } catch {
    // sessionStorage unavailable (private browsing) - treat as already seen
    // rather than forcing the race map on every single match.
    isFirstThisSession = false;
  }
  if (isFirstThisSession) {
    return playerRace === 'Sul' ? 'sul' : 'human';
  }

  return pickRandomMapId();
}

export const SWAMP_FOG_CYCLE = 70;
export const SWAMP_FOG_FADE = 4;
export const SWAMP_FOG_HOLD = 10;
export const SWAMP_FOG_SPAN = SWAMP_FOG_FADE * 2 + SWAMP_FOG_HOLD;

/**
 * Deterministic dense fog bank intensity for the Xeno Swamp map (0.0 to 1.0).
 * Shared identically between simulation (Battlefield / MatchStats fog kills)
 * and renderer (backgroundSwamp.js).
 */
export function getSwampFogIntensity(t, mapSeed = 0) {
  const seedNum = typeof mapSeed === 'number' && Number.isFinite(mapSeed) ? Math.abs(mapSeed) : 42;
  const seedOffset = ((seedNum * 1103515245 + 12345) & 0x7fffffff) % SWAMP_FOG_CYCLE;
  const cyclePos = ((t || 0) + seedOffset) % SWAMP_FOG_CYCLE;
  if (cyclePos > SWAMP_FOG_SPAN) return 0;
  if (cyclePos < SWAMP_FOG_FADE) return cyclePos / SWAMP_FOG_FADE;
  if (cyclePos < SWAMP_FOG_FADE + SWAMP_FOG_HOLD) return 1;
  return 1 - (cyclePos - SWAMP_FOG_FADE - SWAMP_FOG_HOLD) / SWAMP_FOG_FADE;
}
